import TrashBin from './TrashBinIcon.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
};

export const TrashBinIcon = ({ width = '20px', alt = 'Trash bin icon', ...props }: ImageProps) => (
  <div {...props}>
    <img src={TrashBin} width={width} alt={alt} />
  </div>
);
export default TrashBinIcon;
